import { Structure } from './Structure'
import dayJs from 'dayjs'
import { MuiChip } from '../styled'
import { DATE_FORMAT } from 'Shared/constants'

const InfoItem = ({ type, identifier, content, editKey, editing }) => {
  switch (type) {
    case 'dob':
      var date = dayJs(content)
      var data = date.isValid() ? date.format(DATE_FORMAT) : null
      return (
        <Structure
          identifier={identifier}
          data={data}
          extra={` (${dayJs().diff(content, 'year', false)} years old)`}
          editKey={editKey}
          editing={editing}
        />
      )
    case 'date':
      var date = dayJs(content)
      var data = date.isValid() ? date.format(DATE_FORMAT) : null
      return (
        <Structure 
          identifier={identifier} 
          data={data} 
          editKey={editKey}
          editing={editing}
        />
      )
    case 'email':
      return (
        <Structure
          identifier={identifier}
          data={<span className="break-word">{content}</span>}
          editKey={editKey}
          editing={editing}
        />
      )
    case 'multiline':
      return (
        <Structure
          identifier={identifier}
          data={content.split(',').map((line) => (
            <span key={line} style={{ lineHeight: '24px' }}>
              {line}
              <br />
            </span>
          ))}
          editKey={editKey}
          editing={editing}
        />
      )
    case 'positions':
      return (
        <Structure
          identifier={identifier}
          data={content.split(',').map((position, index, array) => (
            <span key={position} style={{ lineHeight: '24px' }} className="dark-grey">
              {position.trim()}
              {index < array.length - 1 && ','}
              <br />
            </span>
          ))}
        />
      )
    case 'positions':
      return (
        <Structure
          identifier={identifier}
          data={content.split(',').map((position, index, array) => (
            <span key={position} style={{ lineHeight: '24px' }} className="dark-grey">
              {position.trim()}
              {index < array.length - 1 && ','}
              <br />
            </span>
          ))}
        />
      )
    case 'named_list':
      return (
        <Structure
          identifier={identifier}
          block
          data={content.map((item, i) => (
            <div key={i} className="margin-bottom">
              {item.name && <MuiChip label={item.name} $tiny />}
              {item.value && <span className="bold">{item.value}</span>}
            </div>
          ))}
          editKey={editKey}
          editing={editing}
        />
      )
    case 'namedBoolean':
      return (
        <Structure
          identifier={identifier}
          data={
            <MuiChip
              label={content.label.toUpperCase()}
              $tiny
              status={content.value.toString()}
            />
          }
        />
      )
    case 'donor_status':
      return <Structure identifier={identifier} data={<span className="orange-100">{content?.toString()}</span>} />
    case 'text':
      return (
        <Structure 
          identifier={identifier} 
          data={content?.toString()} 
          editKey={editKey}
          editing={editing}
        />
      )
  }
}

export default InfoItem
